import { ToothNumeration } from '@/shared/api/protocol-ts/model/dto_report_common_pb';

export const isSupernumeraryTooth = (numeration?: ToothNumeration) =>
  (numeration?.SupernumeraryIndex ?? 0) > 0;
